/**
 * Skid Steer Store — Compatibility Checker Engine
 * Asset file: assets/machines.js
 * Catalog: assets/machine-catalog.js (must load first — defines MACHINES)
 * Loaded by: snippets/compatibility-checker-widget.liquid
 *
 * Entry point: initCompatWidget(productDescriptionHTML, metafields)
 */

(function(w) {
  w.SSS_ANALYTICS = w.SSS_ANALYTICS || { q: [] };
  w.sssTrack = function(eventName, tags) {
    if (!eventName) return;
    w.SSS_ANALYTICS.q.push({ event: eventName, tags: tags || {}, t: Date.now() });
    if (typeof w.sssFlushAnalytics === 'function') w.sssFlushAnalytics();
  };
  w.sssFlushAnalytics = function() {
    var q = w.SSS_ANALYTICS.q || [];
    if (!q.length) return;
    w.dataLayer = w.dataLayer || [];
    var clarityReady = typeof w.clarity === 'function';
    var keep = [];
    for (var i = 0; i < q.length; i++) {
      var item = q[i];
      w.dataLayer.push({ event: 'sss_' + item.event, sss_fit: item.tags });
      if (clarityReady) {
        try {
          w.clarity('event', item.event);
          var tags = item.tags || {};
          for (var k in tags) {
            if (tags[k] != null && tags[k] !== '') w.clarity('set', k, String(tags[k]).slice(0, 255));
          }
        } catch (err) {}
      } else if (Date.now() - item.t < 20000) {
        keep.push(item);
      }
    }
    w.SSS_ANALYTICS.q = keep;
    if (keep.length && !w.SSS_ANALYTICS.timer) {
      w.SSS_ANALYTICS.timer = setTimeout(function() {
        w.SSS_ANALYTICS.timer = null;
        w.sssFlushAnalytics();
      }, 700);
    }
  };
  setTimeout(function() { w.sssFlushAnalytics(); }, 0);
})(window);

function fitTrack(eventName, extra) {
  var tags = extra || {};
  tags.fit_type = tags.fit_type || (STATE && STATE.machineType) || '';
  tags.fit_machine = tags.fit_machine || (STATE && STATE.machineName) || '';
  if (typeof sssTrack === 'function') sssTrack(eventName, tags);
}

function crmConfig() {
  var c = window.SSS_CRM || {};
  var url = String(c.url || '').replace(/\/$/, '');
  if (!url) return null;
  return { url: url, key: c.key || '', product: c.product || {} };
}

function currentVariantRecord() {
  var id = parseInt(currentVariantId(), 10);
  var list = window.SSS_VARIANTS || [];
  for (var i = 0; i < list.length; i++) {
    if (parseInt(list[i].id, 10) === id) return list[i];
  }
  return null;
}

function buildCrmFitPayload(outcome, suggested) {
  if (!STATE || !STATE.machineType || !STATE.machineName) return null;
  var parts = String(STATE.machineName).split(' ');
  var make = parts[0] || '';
  var model = parts.slice(1).join(' ') || STATE.machineName;
  var v = currentVariantRecord();
  var product = (window.SSS_CRM && window.SSS_CRM.product) || {};
  var handle = product.handle || (location.pathname.split('/products/')[1] || '').split('?')[0];
  var payload = {
    outcome: outcome,
    productHandle: handle,
    productTitle: product.title || document.title,
    variantId: v ? String(v.id) : String(currentVariantId() || ''),
    variantTitle: v ? variantLabel(v) : '',
    machine: {
      type: STATE.machineType,
      make: make,
      model: model,
      flowMode: STATE.flowMode
    }
  };
  if (suggested && suggested.variant) payload.suggestedVariantTitle = variantLabel(suggested.variant);
  if (suggested && suggested.related && suggested.related.product) {
    payload.suggestedProductHandle = suggested.related.product.handle || '';
  }
  return payload;
}

function shopifyCustomer() {
  var c = window.SSS_CRM && window.SSS_CRM.customer;
  if (!c) return null;
  return { name: c.name || '', email: c.email || '', phone: c.phone || '' };
}

function mergeCrmIdentity(payload, contact) {
  if (!contact) return payload;
  if (contact.name) payload.name = contact.name;
  if (contact.email) payload.email = contact.email;
  if (contact.phone) payload.phone = contact.phone;
  return payload;
}

function readStoredUtms() {
  var stored = {};
  try { stored = JSON.parse(localStorage.getItem('sss_utm') || '{}'); } catch (e) {}
  var params = new URLSearchParams(window.location.search);
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid'].forEach(function(k) {
    var v = params.get(k);
    if (v) stored[k] = v;
  });
  try { localStorage.setItem('sss_utm', JSON.stringify(stored)); } catch (e2) {}
  return stored;
}

function crmLeadContext() {
  var product = (window.SSS_CRM && window.SSS_CRM.product) || {};
  var handle = product.handle || (location.pathname.split('/products/')[1] || '').split('?')[0];
  var v = currentVariantRecord();
  var utm = readStoredUtms();
  var ctx = {
    productHandle: handle,
    productTitle: product.title || document.title,
    variantId: v ? String(v.id) : String(currentVariantId() || ''),
    variantTitle: v ? variantLabel(v) : '',
    pageUrl: window.location.href,
    utmSource: utm.utm_source || '',
    utmMedium: utm.utm_medium || '',
    utmCampaign: utm.utm_campaign || '',
    utmContent: utm.utm_content || '',
    utmTerm: utm.utm_term || '',
    gclid: utm.gclid || ''
  };
  if (STATE && STATE.machineType && STATE.machineName) {
    var parts = String(STATE.machineName).split(' ');
    ctx.machine = {
      type: STATE.machineType,
      make: parts[0] || '',
      model: parts.slice(1).join(' ') || STATE.machineName,
      flowMode: STATE.flowMode
    };
  }
  return ctx;
}

function postCrm(path, body, keepalive) {
  var cfg = crmConfig();
  if (!cfg) return Promise.resolve();
  var headers = { 'Content-Type': 'application/json' };
  if (cfg.key) headers.Authorization = 'Bearer ' + cfg.key;
  return fetch(cfg.url + path, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body),
    keepalive: !!keepalive
  }).then(function(res) {
    return res.json().then(function(data) {
      if (data && data.fitCheck && data.fitCheck.id) STATE.lastFitCheckId = data.fitCheck.id;
      return data;
    }).catch(function() { return null; });
  }).catch(function() { return null; });
}

function ingestFitCheck(outcome, suggested, source, contact) {
  var payload = buildCrmFitPayload(outcome, suggested);
  if (!payload) return Promise.resolve();
  STATE.lastFitOutcome = outcome;
  STATE.lastFitSuggested = suggested || null;
  if (source) payload.source = source;
  mergeCrmIdentity(payload, shopifyCustomer());
  mergeCrmIdentity(payload, contact);
  return postCrm('/api/fit-checks', payload, !!(contact && (contact.email || contact.phone)));
}

function ingestLead(source, contact) {
  var cfg = crmConfig();
  if (!cfg) return Promise.resolve();
  var keepalive = true;
  var body = crmLeadContext();
  body.source = source;
  if (STATE.lastFitCheckId) body.fitCheckId = STATE.lastFitCheckId;
  mergeCrmIdentity(body, shopifyCustomer());
  mergeCrmIdentity(body, contact);
  return postCrm('/api/leads', body, keepalive);
}

window.sssIngestQuoteLead = window.sssIngestQuoteLead = function(contact) {
  return ingestLead('fit_quote', contact);
};

function parseSpecs(raw, extraText) {
  var t = (raw || '').replace(/<[^>]+>/g,' ').replace(/,/g,'').replace(/&amp;/g,'&').replace(/&#39;/g,"'").replace(/&nbsp;/g,' ');
  var blob = ((extraText || '') + ' ' + t);
  var s = {
    flowMin:null, flowMax:null, psiMax:null, weight:null, coupler:null,
    carrierMin:null, carrierMax:null, machineTypes:[],
    ptoMin:null, ptoMax:null, hitchMin:null, hitchMax:null,
    engineMin:null, engineMax:null
  };

  var fr = t.match(/(\d+\.?\d*)\s*[-–to]+\s*(\d+\.?\d*)\s*GPM/i);
  var fs = t.match(/(\d+\.?\d*)\s*GPM/i);
  if (fr) { s.flowMin = parseFloat(fr[1]); s.flowMax = parseFloat(fr[2]); }
  else if (fs) { s.flowMin = s.flowMax = parseFloat(fs[1]); }

  var pm = t.match(/(\d+\.?\d*)\s*PSI/gi);
  if (pm) {
    var vals = [];
    for (var i = 0; i < pm.length; i++) {
      var m = pm[i].match(/(\d+\.?\d*)/);
      if (m) vals.push(parseFloat(m[1]));
    }
    if (vals.length) s.psiMax = Math.max.apply(null, vals);
  }

  var cmin = blob.match(/(?:minimum|min(?:imum)?)\s*(?:recommended\s*)?(?:carrier|machine|operating)\s*weight[^0-9]{0,24}(\d+\.?\d*)\s*(?:lbs?|pounds?)/i)
    || blob.match(/(\d+\.?\d*)\s*(?:lbs?|pounds?)\s*(?:minimum|min)\s*(?:carrier|machine)/i)
    || blob.match(/(?:for|fits)\s*(?:machines?|carriers?)\s*(?:from\s*)?(\d+\.?\d*)\s*(?:lbs?|pounds?)\s*(?:and\s*(?:up|above)|(?:or|&)\s*(?:larger|heavier)|min)/i);
  var cmax = blob.match(/(?:maximum|max(?:imum)?)\s*(?:recommended\s*)?(?:carrier|machine|operating)\s*weight[^0-9]{0,24}(\d+\.?\d*)\s*(?:lbs?|pounds?)/i)
    || blob.match(/(\d+\.?\d*)\s*(?:lbs?|pounds?)\s*(?:maximum|max)\s*(?:carrier|machine)/i)
    || blob.match(/(?:up to|not to exceed|max(?:imum)?)\s*(\d+\.?\d*)\s*(?:lbs?|pounds?)\s*(?:carrier|machine|operating)\s*weight/i);
  if (cmin) s.carrierMin = parseFloat(cmin[1]);
  if (cmax) s.carrierMax = parseFloat(cmax[1]);

  var wm = t.match(/(\d+\.?\d*)\s*(?:lbs?|pounds?)\b/i);
  if (wm) {
    var w = parseFloat(wm[1]);
    if (w !== s.carrierMin && w !== s.carrierMax) s.weight = w;
  }

  var couplers = [
    ['Bobcat MT',                  /bobcat\s*mt\b|mt[\s-]?series\s*mount/i],
    ['ASV',                        /\basv\b(?![\s-]*rt-?(?:75|120|135))/i],
    ['Universal Mini SSL',         /universal\s*mini\s*(skid\s*steer|ssl)|mini\s*(skid\s*steer|ssl)\s*(?:quick[\s-]?attach|mount|universal)/i],
    ['Mini SSL',                   /mini\s*ssl/i],
    ['3-Point Hitch',              /3[\s-]?point|category\s*[123]\s*hitch/i],
    ['Wain-Roy',                   /wain[\s-]?roy/i],
    ['Wedge Mount',                /wedge[\s-]?mount/i],
    ['Pin Grabber',                /pin[\s-]?grabber|quick\s*coupler|pin\s*grabber/i],
    ['Bob-Tach',                   /bob.?tach/i],
    ['Universal Skid Steer (SSL)', /universal\s*(skid\s*steer|ssl)|skid\s*steer\s*quick[\s-]?attach/i],
    ['Deere Quik-Tatch',           /quik.?tatch|deere\s*quick/i],
    ['Cat IT',                     /cat\s*it\b/i],
    ['Kubota K-Series',            /kubota\s*k.series/i],
    ['CAT Pin-On',                 /cat\s*pin.?on/i],
    ['Pin-On',                     /\bpin.?on\b/i],
    ['Universal',                  /\buniversal\b/i]
  ];
  for (var c = 0; c < couplers.length; c++) {
    if (couplers[c][1].test(blob)) { s.coupler = couplers[c][0]; break; }
  }

  s.machineTypes = parseMachineTypes(blob, s.coupler);

  var tableHp = parseHpTableForModel(raw, parseModelCode(extraText) || parseModelCode(t));
  if (tableHp) {
    applyTableHpToSpecs(s, tableHp);
  } else {
    var ptoRange = t.match(/(\d+\.?\d*)\s*[-–to]+\s*(\d+\.?\d*)\s*(?:PTO\s*)?(?:hp|HP)/i)
      || t.match(/PTO[:\s]+(\d+\.?\d*)\s*[-–to]+\s*(\d+\.?\d*)/i);
    var ptoMinM = t.match(/(?:min(?:imum)?|requires?|needed|rated)\s*(?:of\s*)?(\d+\.?\d*)\s*(?:PTO\s*)?(?:hp|HP)/i)
      || t.match(/(\d+\.?\d*)\s*(?:hp|HP)\s*PTO/i)
      || t.match(/PTO\s*(?:hp|HP)?[:\s]*(\d+\.?\d*)/i);
    if (ptoRange) { s.ptoMin = parseFloat(ptoRange[1]); s.ptoMax = parseFloat(ptoRange[2]); }
    else if (ptoMinM) { s.ptoMin = parseFloat(ptoMinM[1]); }
    var ptoMaxM = t.match(/(?:max(?:imum)?)\s*(?:of\s*)?(\d+\.?\d*)\s*(?:PTO\s*)?(?:hp|HP)/i);
    if (ptoMaxM && !s.ptoMax) s.ptoMax = parseFloat(ptoMaxM[1]);
  }

  var hitchCats = [];
  var hitchRe = /(?:category|cat\.?)\s*([123])(?:\s*(?:[-–/&]|and|or)\s*([123]))?/gi;
  var hm;
  while ((hm = hitchRe.exec(blob))) {
    hitchCats.push(parseInt(hm[1], 10));
    if (hm[2]) hitchCats.push(parseInt(hm[2], 10));
  }
  if (hitchCats.length) {
    s.hitchMin = Math.min.apply(null, hitchCats);
    s.hitchMax = Math.max.apply(null, hitchCats);
  }

  return s;
}

function parseModelCode(text) {
  var m = String(text || '').toUpperCase().match(/\b([A-Z]{1,4}\d{2,4}[A-Z]{0,3})\b/);
  return m ? m[1] : null;
}

function cellText(html) {
  return String(html || '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim();
}

function parseHtmlTableRows(tableHtml) {
  var rows = [];
  var re = /<tr[^>]*>([\s\S]*?)<\/tr>/gi;
  var m;
  while ((m = re.exec(tableHtml))) {
    var cells = [];
    var cre = /<t[hd][^>]*>([\s\S]*?)<\/t[hd]>/gi;
    var c;
    while ((c = cre.exec(m[1]))) cells.push(cellText(c[1]));
    if (cells.length) rows.push(cells);
  }
  return rows;
}

function specLabelKey(label) {
  var l = String(label || '').toLowerCase();
  if (/min(?:imum)?\s*engine/.test(l)) return 'engineMin';
  if (/max(?:imum)?\s*engine/.test(l)) return 'engineMax';
  if (/min(?:imum)?\s*pto/.test(l)) return 'ptoMin';
  if (/max(?:imum)?\s*pto/.test(l)) return 'ptoMax';
  if (/hitch/.test(l)) return 'hitch';
  return null;
}

function cellModelMatch(cell, modelU) {
  var c = String(cell || '').toUpperCase().trim();
  if (!c) return false;
  if (c === modelU) return true;
  return c.split(/\s+/)[0] === modelU;
}

function hitchFromCell(val) {
  var cats = String(val || '').match(/[123]/g);
  if (!cats || !cats.length) return null;
  var nums = cats.map(Number);
  return { hitchMin: Math.min.apply(null, nums), hitchMax: Math.max.apply(null, nums) };
}

function assignHpField(out, key, val) {
  if (key === 'hitch') {
    var h = hitchFromCell(val);
    if (h) { out.hitchMin = h.hitchMin; out.hitchMax = h.hitchMax; }
    return;
  }
  var num = parseFloat(String(val || '').replace(/,/g, ''));
  if (isFinite(num)) out[key] = num;
}

function hpResultOk(out) {
  return !!(out && (out.engineMin != null || out.engineMax != null || out.ptoMin != null || out.ptoMax != null || out.hitchMin != null));
}

function parseHpModelsAsColumns(rows, modelU) {
  var col = -1;
  var scan = Math.min(rows.length, 4);
  for (var r = 0; r < scan && col < 0; r++) {
    for (var i = 1; i < rows[r].length; i++) {
      if (cellModelMatch(rows[r][i], modelU)) { col = i; break; }
    }
  }
  if (col < 1) return null;
  var out = {};
  for (var rr = 0; rr < rows.length; rr++) {
    var key = specLabelKey(rows[rr][0]);
    if (!key) continue;
    assignHpField(out, key, rows[rr][col]);
  }
  return hpResultOk(out) ? out : null;
}

function parseHpModelsAsRows(rows, modelU) {
  var header = rows[0];
  var idx = {};
  var specCols = 0;
  for (var i = 0; i < header.length; i++) {
    var k = specLabelKey(header[i]);
    if (k) { idx[k] = i; specCols++; }
  }
  if (specCols < 2) return null;
  for (var r = 1; r < rows.length; r++) {
    var row = rows[r];
    var hit = false;
    for (var c = 0; c < Math.min(2, row.length); c++) {
      if (cellModelMatch(row[c], modelU)) { hit = true; break; }
    }
    if (!hit) continue;
    var out = {};
    for (var key in idx) {
      if (Object.prototype.hasOwnProperty.call(idx, key)) assignHpField(out, key, row[idx[key]]);
    }
    if (hpResultOk(out)) return out;
  }
  return null;
}

function parseHpTableForModel(html, model) {
  if (!html || !model) return null;
  var modelU = String(model).toUpperCase();
  var tables = String(html).match(/<table[\s\S]*?<\/table>/gi) || [];
  for (var t = 0; t < tables.length; t++) {
    var rows = parseHtmlTableRows(tables[t]);
    if (rows.length < 2) continue;
    var parsed = parseHpModelsAsRows(rows, modelU) || parseHpModelsAsColumns(rows, modelU);
    if (parsed) return parsed;
  }
  return null;
}

function applyTableHpToSpecs(specs, hp) {
  if (!specs || !hp) return specs;
  specs.engineMin = hp.engineMin != null ? hp.engineMin : null;
  specs.engineMax = hp.engineMax != null ? hp.engineMax : null;
  specs.ptoMin = hp.ptoMin != null ? hp.ptoMin : null;
  specs.ptoMax = hp.ptoMax != null ? hp.ptoMax : (hp.engineMax != null ? hp.engineMax : null);
  if (hp.hitchMin != null) specs.hitchMin = hp.hitchMin;
  if (hp.hitchMax != null) specs.hitchMax = hp.hitchMax;
  return specs;
}

function applyTableHpOverlay(specs, html, extraText) {
  var model = parseModelCode(extraText) || parseModelCode((html || '').replace(/<[^>]+>/g, ' '));
  var hp = parseHpTableForModel(html, model);
  if (hp) applyTableHpToSpecs(specs, hp);
  return specs;
}

var TYPE_LABELS = {
  'skid-steer': 'Skid Steer',
  'mini-skid-steer': 'Mini Skid Steer',
  'excavator': 'Excavator',
  'mini-excavator': 'Mini Excavator',
  'loader': 'Loader',
  'tractor': 'Tractor',
  'material-handler': 'Material Handler'
};

function parseMachineTypes(text, coupler) {
  var types = [];
  var add = function(t) { if (types.indexOf(t) === -1) types.push(t); };
  if (/3[\s-]?point|category\s*[123]|tractor hitch|\btractor\b/i.test(text)) add('tractor');
  if (/mini[\s-]?skid|mini\s*ssl|dingo|boxer\b|bobcat\s*mt|walk[\s-]?behind|stand[\s-]?on mini/i.test(text)) add('mini-skid-steer');
  if (/mini[\s-]?ex/i.test(text)) add('mini-excavator');
  else if (/excavator/i.test(text)) add('excavator');
  if (/\bctl\b|compact track loader|skid[\s-]?steer|full[\s-]?size skid/i.test(text) && types.indexOf('mini-skid-steer') === -1) {
    add('skid-steer'); add('loader');
  }
  if (/material[\s-]?handler|scrap[\s-]?handler|orange[\s-]?peel|\bMH\d{3,}/i.test(text)) add('material-handler');
  if (/wheel\s*loader/i.test(text)) add('loader');

  if (!types.length && coupler) {
    if (coupler === '3-Point Hitch') add('tractor');
    if (coupler === 'Bobcat MT' || coupler === 'ASV' || coupler === 'Universal Mini SSL' || coupler === 'Mini SSL') add('mini-skid-steer');
    if (coupler === 'Bob-Tach' || coupler === 'Universal Skid Steer (SSL)' || coupler === 'Deere Quik-Tatch' || coupler === 'Cat IT' || coupler === 'Kubota K-Series') {
      add('skid-steer'); add('loader');
    }
    if (coupler === 'Pin-On' || coupler === 'CAT Pin-On' || coupler === 'Pin Grabber' || coupler === 'Wedge Mount' || coupler === 'Wain-Roy') {
      add('excavator'); add('mini-excavator'); add('material-handler');
    }
  }
  return types;
}

function typeFamily(t) {
  if (t === 'loader' || t === 'skid-steer') return 'ssl';
  if (t === 'excavator' || t === 'mini-excavator' || t === 'material-handler') return 'ex';
  return t;
}

function machineTypeCompat(attTypes, selected) {
  if (!attTypes || !attTypes.length || !selected) return 'unknown';
  if (attTypes.indexOf(selected) !== -1) return 'ok';
  var fam = typeFamily(selected);
  for (var i = 0; i < attTypes.length; i++) {
    if (typeFamily(attTypes[i]) === fam) {
      // Mini vs standard excavator is the same pin-on family; carrier class decides size.
      if (fam === 'ex') return 'ok';
      return 'warn';
    }
  }
  return 'fail';
}

function machineCarrierWeight(type, specs) {
  if (!specs) return { lbs: null, estimated: false };
  if (specs.opWeight) return { lbs: specs.opWeight, estimated: false };
  if (type === 'excavator' || type === 'mini-excavator' || type === 'material-handler') return { lbs: specs.capacity || null, estimated: false };
  if (type === 'tractor') return { lbs: null, estimated: false };
  if (type === 'mini-skid-steer' && specs.capacity) return { lbs: specs.capacity * 4, estimated: true };
  if ((type === 'skid-steer' || type === 'loader') && specs.capacity) return { lbs: specs.capacity * 3.3, estimated: true };
  return { lbs: null, estimated: false };
}

function machineCoupler(type, specs) {
  if (type === 'tractor') return (specs && specs.coupler) || '3-Point Hitch';
  return specs && specs.coupler ? specs.coupler : null;
}

function catalogMakes(type) {
  var set = {};
  if (typeof MACHINES !== 'undefined' && MACHINES[type] && MACHINES[type].makes) {
    Object.keys(MACHINES[type].makes).forEach(function(make) { set[make] = 1; });
  }
  if (typeof OEM_SPECS !== 'undefined' && OEM_SPECS[type]) {
    Object.keys(OEM_SPECS[type]).forEach(function(make) { set[make] = 1; });
  }
  return Object.keys(set).sort();
}

function catalogModels(type, make) {
  var set = {};
  if (typeof MACHINES !== 'undefined' && MACHINES[type] && MACHINES[type].makes[make]) {
    Object.keys(MACHINES[type].makes[make]).forEach(function(model) { set[model] = 1; });
  }
  if (typeof OEM_SPECS !== 'undefined' && OEM_SPECS[type] && OEM_SPECS[type][make]) {
    Object.keys(OEM_SPECS[type][make]).forEach(function(model) { set[model] = 1; });
  }
  return Object.keys(set).sort(function(a, b) {
    return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
  });
}

function formatFlow(min, max) {
  if (min == null && max == null) return '—';
  if (min == null) return String(max);
  if (max == null || Number(min) === Number(max)) return String(min);
  return min + '–' + max;
}

/* OEM rows match variant_id. Blank imports leave catalog values in place.
   Optional hydraulic packages do not inherit base weight or rated capacity.
   Held and reference-only evidence is absent from OEM_SPECS. */
function resolveFitSpecs(type, make, model, flowMode) {
  var legacy = null;
  if (typeof MACHINES !== 'undefined' && MACHINES[type] && MACHINES[type].makes[make]) {
    legacy = MACHINES[type].makes[make][model] || null;
  }
  var oem = null;
  if (typeof OEM_SPECS !== 'undefined' && OEM_SPECS[type] && OEM_SPECS[type][make]) {
    oem = OEM_SPECS[type][make][model] || null;
  }
  if (!legacy && !oem) return null;

  var specs = {};
  if (legacy) Object.keys(legacy).forEach(function(key) { specs[key] = legacy[key]; });
  specs.fitmentVerified = false;
  specs.variantIds = [];
  specs.packages = {};
  specs.specNotes = [];
  if (!oem) return specs;

  function blocked(pack, field) {
    return !!(pack && pack.conflicts && pack.conflicts.indexOf(field) !== -1);
  }
  var std = oem.standard || null;
  var uns = oem.unspecified || null;
  if (std && std.flow != null && !blocked(std, 'flow')) {
    specs.flowMin = std.flowMin != null ? std.flowMin : std.flow;
    specs.flowMax = std.flow;
  }
  if (std && std.auxPsi != null && !blocked(std, 'auxPsi')) specs.auxPsiStandard = std.auxPsi;
  if (std && std.roc != null && !blocked(std, 'roc')) specs.capacity = std.roc;
  else if ((!std || !blocked(std, 'roc')) && uns && uns.roc != null && !blocked(uns, 'roc')) specs.capacity = uns.roc;
  if (std && std.weight != null && !blocked(std, 'weight')) specs.opWeight = std.weight;
  else if ((!std || !blocked(std, 'weight')) && uns && uns.weight != null && !blocked(uns, 'weight')) specs.opWeight = uns.weight;

  Object.keys(oem).forEach(function(name) {
    var pack = oem[name];
    if (!pack) return;
    if (pack.ids) specs.variantIds = specs.variantIds.concat(pack.ids);
    if (pack.conflicts && pack.conflicts.length) {
      specs.specNotes.push('OEM ' + (pack.label || name) + ' values disagree, so the existing figure was kept for ' + pack.conflicts.join(', ') + '.');
    }
    if (name === 'standard' || name === 'unspecified') return;
    var entry = { label: pack.label || name, ids: pack.ids || [] };
    if (pack.flow != null && !blocked(pack, 'flow')) {
      entry.flowMin = pack.flowMin != null ? pack.flowMin : pack.flow;
      entry.flowMax = pack.flow;
    }
    if (pack.auxPsi != null && !blocked(pack, 'auxPsi')) entry.auxPsi = pack.auxPsi;
    if (name === 'high' && entry.flowMin != null) {
      specs.hfFlowMin = entry.flowMin;
      specs.hfFlowMax = entry.flowMax;
    }
    specs.packages[name] = entry;
  });

  var seen = {};
  specs.variantIds = specs.variantIds.filter(function(id) {
    if (seen[id]) return false;
    seen[id] = 1;
    return true;
  });
  specs.specNotes.push('Figures apply to the documented configuration only. Installed fitment is not verified.');
  return specs;
}

function activeHydraulics(ms, flowMode) {
  var mode = flowMode || 'standard';
  var pack = ms && ms.packages && ms.packages[mode];
  if (mode !== 'standard' && pack && pack.flowMin != null) {
    return {
      optional: true,
      label: pack.label || mode,
      flowMin: pack.flowMin,
      flowMax: pack.flowMax,
      psi: pack.auxPsi != null ? pack.auxPsi : (ms.psiMax || null)
    };
  }
  if (mode === 'high' && ms && ms.hfFlowMin) {
    return {
      optional: true,
      label: 'High Flow',
      flowMin: ms.hfFlowMin,
      flowMax: ms.hfFlowMax,
      psi: ms.psiMax || null
    };
  }
  return {
    optional: false,
    label: 'Standard',
    flowMin: ms ? ms.flowMin : null,
    flowMax: ms ? ms.flowMax : null,
    psi: ms && ms.auxPsiStandard != null ? ms.auxPsiStandard : ((ms && ms.psiMax) || null)
  };
}


/* ══════════════════════════════════════════════════════════
   COUPLER COMPATIBILITY
   ══════════════════════════════════════════════════════════ */
function isUniversalSslMount(name) {
  if (!name) return false;
  var n = String(name).toLowerCase();
  if (n === 'universal') return true;
  if (/bob[\s-]?tach/.test(n)) return true;
  if (/quik[\s-]?tatch|quick[\s-]?tatch|deere\s*quick/.test(n)) return true;
  if (/\bcat\s*it\b/.test(n)) return true;
  if (/kubota\s*k/.test(n)) return true;
  if (/new\s*holland/.test(n)) return true;
  if (n === 'universal ssl') return true;
  if (/universal\s*(skid\s*steer|ssl)/.test(n)) return true;
  if (/skid\s*steer\s*(quick[\s-]?attach|coupler|mount|plate)/.test(n)) return true;
  var ssl = ['Bob-Tach','Universal Skid Steer (SSL)','Deere Quik-Tatch','Cat IT','Kubota K-Series','New Holland','Universal'];
  return ssl.indexOf(name) !== -1;
}

function normalizeCouplerName(name) {
  if (!name) return name;
  var n = String(name).trim();
  var low = n.toLowerCase();
  if (low === 'mini ssl') return 'Universal Mini SSL';
  if (low === 'cat pin-on' || low === 'cat pin on') return 'Pin-On';
  if (low === 'universal ssl' || low === 'universal skid steer') return 'Universal Skid Steer (SSL)';
  if (/mini\s*\/\s*bobcat\s*mt|bobcat\s*mt/.test(low)) return 'Bobcat MT';
  if (/pin[\s-]?on\s*\/\s*pin[\s-]?grabber/.test(low)) return 'Pin-On';
  if (/^3[\s-]?point$/.test(low) || low === '3-point hitch') return '3-Point Hitch';
  if (/quick\s*hitch/.test(low)) return 'Pin Grabber';
  if (/^wedge$/.test(low)) return 'Wedge Mount';
  return n;
}

function isExcavatorStickMount(name) {
  if (!name) return false;
  var n = String(name).toLowerCase();
  return /pin[\s-]?on|pin[\s-]?grabber|wedge|wain[\s-]?roy|quick hitch|cat pin/.test(n);
}

function isExcavatorMachineCoupler(name) {
  if (!name) return false;
  var n = String(name).toLowerCase();
  if (isExcavatorStickMount(n)) return true;
  // Catalog historically labeled Kubota minis as K-Series (SSL name). Stick is still pin-on.
  if (/kubota\s*k/.test(n)) return true;
  return false;
}

function attachmentListsSelectedMachine(as, machineName) {
  var blob = String((as && (as.extraText || as.productTitle)) || '').toLowerCase();
  var name = String(machineName || (typeof STATE !== 'undefined' && STATE.machineName) || '').toLowerCase();
  if (!blob || !name) return false;
  var parts = name.trim().split(/\s+/);
  var model = parts.length > 1 ? parts.slice(1).join(' ') : name;
  if (!model || model.length < 3) return false;
  var compactBlob = blob.replace(/[\s_\-]/g, '');
  var compactModel = model.replace(/[\s_\-]/g, '');
  if (compactModel.length >= 4 && compactBlob.indexOf(compactModel) !== -1) return true;
  if (blob.indexOf(model) !== -1) return true;
  return false;
}

function couplerCompat(att, mach, machineType) {
  if (!att || !mach) return 'unknown';
  var alias = function(x) {
    if (x === 'Mini SSL') return 'Universal Mini SSL';
    if (x === 'CAT Pin-On') return 'Pin-On';
    return normalizeCouplerName(x);
  };
  var parts = String(att).split(/\s*,\s*/);
  var best = 'fail';
  var rank = { ok: 3, adapter: 2, unknown: 1, fail: 0 };
  for (var i = 0; i < parts.length; i++) {
    var one = couplerCompatOne(alias(parts[i]), alias(mach), machineType);
    if (rank[one] > rank[best]) best = one;
    if (best === 'ok') return 'ok';
  }
  return best;
}

function couplerCompatOne(att, mach, machineType) {
  if (!att || !mach) return 'unknown';
  if (att === mach) return 'ok';
  var ex = machineType === 'excavator' || machineType === 'mini-excavator' || machineType === 'material-handler';
  if (ex && isExcavatorStickMount(att) && isExcavatorMachineCoupler(mach)) return 'ok';
  // Full-size skid steer / CTL plates are the same ISO universal mount.
  // Brand names (Bob-Tach, Quik-Tatch, Cat IT, etc.) still pass.
  if (!ex && isUniversalSslMount(att) && isUniversalSslMount(mach)) return 'ok';

  if ((att === 'Pin-On' && mach === 'Pin Grabber') || (att === 'Pin Grabber' && mach === 'Pin-On')) {
    return att === 'Pin-On' ? 'ok' : 'adapter';
  }

  var mini = ['Universal Mini SSL','Bobcat MT','ASV'];
  if (mini.indexOf(att) !== -1 && mini.indexOf(mach) !== -1) return 'fail';

  return 'fail';
}


/* ══════════════════════════════════════════════════════════
   STATE
   ══════════════════════════════════════════════════════════ */
var STATE = window.SSS_FIT_STATE = window.SSS_FIT_STATE || {
  machineType: null,
  machineSpecs: null,
  flowMode: 'standard',
  attSpecs: null,
  machineName: '',
  _models: []
};


/* ══════════════════════════════════════════════════════════
   CHIP STRIP UPDATE
   ══════════════════════════════════════════════════════════ */
function setChip(id, text, dim) {
  var el = document.getElementById(id);
  if (!el) return;
  el.textContent = text;
  var pip = el.closest('.sw-pip');
  if (pip) {
    if (dim) pip.classList.add('dim');
    else pip.classList.remove('dim');
  }
}

function updateParsedStrip() {
  var s = STATE.attSpecs;
  if (!s) return;
  var fv = s.flowMin && s.flowMax
    ? (s.flowMin === s.flowMax ? String(s.flowMin) : s.flowMin + '–' + s.flowMax)
    : 'n/a';
  setChip('chip-flow-val', fv, !s.flowMin);
  setChip('chip-psi-val', s.psiMax ? s.psiMax.toLocaleString() : 'n/a', !s.psiMax);
  setChip('chip-weight-val', s.weight ? s.weight.toLocaleString() : 'n/a', !s.weight);
  setChip('chip-coupler-val', s.coupler || '?', !s.coupler);
  var typeText = (s.machineTypes && s.machineTypes.length)
    ? s.machineTypes.map(function(t) { return TYPE_LABELS[t] || t; }).join(', ')
    : '?';
  setChip('chip-type-val', typeText, !(s.machineTypes && s.machineTypes.length));
  var carText = 'n/a';
  if (s.carrierMin && s.carrierMax) carText = s.carrierMin.toLocaleString() + '–' + s.carrierMax.toLocaleString();
  else if (s.carrierMin) carText = s.carrierMin.toLocaleString() + '+';
  else if (s.carrierMax) carText = '≤' + s.carrierMax.toLocaleString();
  setChip('chip-carrier-val', carText, !s.carrierMin && !s.carrierMax);
  var ptoText = 'n/a';
  if (s.ptoMin && s.ptoMax) ptoText = s.ptoMin + '–' + s.ptoMax;
  else if (s.ptoMin) ptoText = s.ptoMin + '+';
  else if (s.ptoMax) ptoText = '≤' + s.ptoMax;
  setChip('chip-pto-val', ptoText, !s.ptoMin && !s.ptoMax);
}


/* ══════════════════════════════════════════════════════════
   SELECT MACHINE TYPE
   ══════════════════════════════════════════════════════════ */
function selectType(btn) {
  var btns = document.querySelectorAll('.sw-type');
  for (var i = 0; i < btns.length; i++) btns[i].classList.remove('active');
  btn.classList.add('active');
  STATE.machineType = btn.dataset.type;
  STATE.flowMode = 'standard';

  document.getElementById('sw-machine-preview').classList.remove('visible');
  document.getElementById('sw-check-btn').disabled = true;
  document.getElementById('sw-results').classList.remove('visible');

  var makeEl  = document.getElementById('sw-make');
  var modelEl = document.getElementById('sw-model');
  makeEl.innerHTML  = '<option value="">— Select Make —</option>';
  modelEl.innerHTML = '<option value="">— Select Model —</option>';

  var typeData = typeof MACHINES !== 'undefined' ? MACHINES[STATE.machineType] : null;
  if (!STATE._restore) fitTrack('fit_type', { fit_type: STATE.machineType });
  if (!typeData && !(typeof OEM_SPECS !== 'undefined' && OEM_SPECS[STATE.machineType])) return;
  var makes = catalogMakes(STATE.machineType);
  for (var j = 0; j < makes.length; j++) {
    var o = document.createElement('option');
    o.value = makes[j]; o.textContent = makes[j];
    makeEl.appendChild(o);
  }

  document.getElementById('sw-selects').classList.remove('locked');
  var search = document.getElementById('sw-model-search');
  if (search) search.value = '';

  var toggle = document.getElementById('sw-flow-toggle');
  if (typeData && typeData.supportsHighFlow) toggle.classList.add('visible');
  else toggle.classList.remove('visible');

  var flowOpts = document.querySelectorAll('.sw-flow-opt');
  for (var k = 0; k < flowOpts.length; k++) flowOpts[k].classList.remove('active');
  document.querySelector('.sw-flow-opt[data-flow="standard"]').classList.add('active');
  document.getElementById('std-flow-gpms').textContent = '—';
  document.getElementById('hf-flow-gpms').textContent  = '—';
  document.getElementById('sw-flow-badge').classList.remove('visible');
}


/* ══════════════════════════════════════════════════════════
   HIGH-FLOW TOGGLE
   ══════════════════════════════════════════════════════════ */
function selectFlowType(el) {
  var opts = document.querySelectorAll('.sw-flow-opt');
  for (var i = 0; i < opts.length; i++) opts[i].classList.remove('active');
  el.classList.add('active');
  STATE.flowMode = el.dataset.flow;
  var makeEl = document.getElementById('sw-make');
  var modelEl = document.getElementById('sw-model');
  if (makeEl && modelEl && makeEl.value && modelEl.value) {
    STATE.machineSpecs = resolveFitSpecs(STATE.machineType, makeEl.value, modelEl.value, STATE.flowMode);
  }
  if (STATE.machineSpecs) {
    renderMachinePreview();
    persistMachine();
  }
  updateFlowBadge();
}

function updateFlowBadge() {
  var badge = document.getElementById('sw-flow-badge');
  var text  = document.getElementById('sw-flow-badge-text');
  if (STATE.machineSpecs) {
    badge.classList.add('visible');
    if (STATE.machineType === 'tractor') {
      var s = STATE.machineSpecs;
      var flow = s.auxFlowMin === s.auxFlowMax ? s.auxFlowMin : s.auxFlowMin + '–' + s.auxFlowMax;
      text.textContent = 'Aux flow \u2014 ' + flow + ' GPM';
    } else {
      var active = activeHydraulics(STATE.machineSpecs, STATE.flowMode);
      text.textContent = active.optional
        ? active.label + ' selected \u2014 ' + formatFlow(active.flowMin, active.flowMax) + ' GPM'
        : 'Standard flow \u2014 ' + formatFlow(active.flowMin, active.flowMax) + ' GPM';
    }
  } else {
    badge.classList.remove('visible');
  }
}


/* ══════════════════════════════════════════════════════════
   UPDATE MODELS DROPDOWN
   ══════════════════════════════════════════════════════════ */
function updateModels() {
  var make   = document.getElementById('sw-make').value;
  var modelEl = document.getElementById('sw-model');
  modelEl.innerHTML = '<option value="">— Select Model —</option>';
  document.getElementById('sw-machine-preview').classList.remove('visible');
  document.getElementById('sw-check-btn').disabled = true;
  document.getElementById('sw-flow-badge').classList.remove('visible');
  var search = document.getElementById('sw-model-search');
  if (search) search.value = '';
  if (!make || !STATE.machineType) return;

  var models = catalogModels(STATE.machineType, make);
  STATE._models = models;
  fillModelOptions('');
}

function fillModelOptions(query) {
  var modelEl = document.getElementById('sw-model');
  var q = (query || '').toLowerCase().trim();
  var models = STATE._models || [];
  var selected = modelEl.value;
  modelEl.innerHTML = '<option value="">— Select Model —</option>';
  var shown = 0;
  for (var i = 0; i < models.length; i++) {
    if (q && models[i].toLowerCase().indexOf(q) === -1) continue;
    var o = document.createElement('option');
    o.value = models[i]; o.textContent = models[i];
    modelEl.appendChild(o);
    shown++;
  }
  if (selected && shown) {
    modelEl.value = selected;
    if (modelEl.value !== selected) modelEl.selectedIndex = 0;
  }
}

function filterModels() {
  var search = document.getElementById('sw-model-search');
  fillModelOptions(search ? search.value : '');
}


/* ══════════════════════════════════════════════════════════
   MACHINE PREVIEW
   ══════════════════════════════════════════════════════════ */
function updateMachinePreview() {
  var make  = document.getElementById('sw-make').value;
  var model = document.getElementById('sw-model').value;
  if (!make || !model || !STATE.machineType) return;

  var specs = resolveFitSpecs(STATE.machineType, make, model, STATE.flowMode);
  if (!specs) return;
  STATE.machineSpecs = specs;
  syncPackageOptions(specs);
  STATE.machineName  = make + ' ' + model;
  persistMachine();
  if (!STATE._restore) fitTrack('fit_machine', { fit_make: make, fit_model: model });

  if (STATE.machineType === 'tractor') {
    renderMachinePreview();
    document.getElementById('sw-check-btn').disabled = false;
    document.getElementById('sw-results').classList.remove('visible');
    updateFlowBadge();
    return;
  }

  document.getElementById('std-flow-gpms').textContent = formatFlow(specs.flowMin, specs.flowMax) + (specs.flowMin != null ? ' GPM' : '');
  var highPack = specs.packages && specs.packages.high;
  var highMin = highPack && highPack.flowMin != null ? highPack.flowMin : specs.hfFlowMin;
  var highMax = highPack && highPack.flowMax != null ? highPack.flowMax : specs.hfFlowMax;
  if (highMin) {
    document.getElementById('hf-flow-gpms').textContent = formatFlow(highMin, highMax) + ' GPM';
    document.querySelector('.sw-flow-opt[data-flow="high"]').style.opacity = '1';
    document.querySelector('.sw-flow-opt[data-flow="high"]').style.pointerEvents = '';
  } else {
    document.getElementById('hf-flow-gpms').textContent = 'Not available';
    var hfOpt = document.querySelector('.sw-flow-opt[data-flow="high"]');
    hfOpt.style.opacity = '0.45';
    hfOpt.style.pointerEvents = 'none';
    hfOpt.classList.remove('active');
    document.querySelector('.sw-flow-opt[data-flow="standard"]').classList.add('active');
    STATE.flowMode = 'standard';
  }

  specs = resolveFitSpecs(STATE.machineType, make, model, STATE.flowMode);
  STATE.machineSpecs = specs;
  renderMachinePreview();
  document.getElementById('sw-check-btn').disabled = false;
  document.getElementById('sw-results').classList.remove('visible');
  updateFlowBadge();
}

function renderMachinePreview() {
  var specs = STATE.machineSpecs;
  var titleEl = document.getElementById('sw-preview-title');
  var chipsEl = document.getElementById('sw-preview-chips');

  if (STATE.machineType === 'tractor') {
    var auxFlow = specs.auxFlowMin === specs.auxFlowMax
      ? specs.auxFlowMin + ' GPM'
      : specs.auxFlowMin + '–' + specs.auxFlowMax + ' GPM';
    titleEl.textContent = STATE.machineName;
    var pairs = [
      ['Aux Flow', auxFlow],
      ['Max PSI', specs.psiMax ? specs.psiMax.toLocaleString() + ' PSI' : 'N/A'],
      ['Engine HP', specs.engineHP ? specs.engineHP + ' hp' : 'N/A'],
      ['PTO HP', specs.ptoHP ? specs.ptoHP + ' hp' : 'N/A'],
      ['Hitch', specs.hitch ? 'Cat ' + specs.hitch : '3-point']
    ];
    chipsEl.innerHTML = pairs.map(function(p) {
      return '<div class="sw-mc-chip">' + p[0] + ': <span>' + p[1] + '</span></div>';
    }).join('');
    if (specs.note) {
      chipsEl.innerHTML += '<div class="sw-mc-chip" style="font-size:0.78rem;color:#888;">\u2139\uFE0F ' + specs.note + '</div>';
    }
    document.getElementById('sw-machine-preview').classList.add('visible');
    return;
  }

  var active = activeHydraulics(specs, STATE.flowMode);
  var gpms = formatFlow(active.flowMin, active.flowMax);

  titleEl.textContent = STATE.machineName + (active.optional ? ' (' + active.label + ')' : '');
  var pairs2 = [
    ['Flow', gpms + (active.flowMin != null ? ' GPM' : '') + (active.optional ? ' \u26A1' : '')],
    ['Max PSI', active.psi ? Number(active.psi).toLocaleString() : 'N/A'],
    ['Op. Cap.', specs.capacity ? specs.capacity.toLocaleString() + ' lbs' : 'N/A'],
    ['Coupler', specs.coupler || 'Not verified']
  ];
  chipsEl.innerHTML = pairs2.map(function(p) {
    return '<div class="sw-mc-chip">' + p[0] + ': <span>' + (p[1] || 'N/A') + '</span></div>';
  }).join('');
  var notes = (specs.specNotes || []).slice();
  if (active.optional && specs.capacity) {
    notes.push('Rated capacity is the base configuration, not the optional hydraulic package.');
  }
  if (active.optional && !(specs.packages && specs.packages[STATE.flowMode] && specs.packages[STATE.flowMode].auxPsi != null)) {
    notes.push('Optional-package pressure was not published. Pressure shown is the existing catalog value.');
  }
  if (notes.length) {
    chipsEl.innerHTML += '<div class="sw-mc-chip" style="font-size:0.78rem;color:#888;">\u2139\uFE0F ' + escapeHtml(notes[0]) + '</div>';
  }
  document.getElementById('sw-machine-preview').classList.add('visible');
}

function syncPackageOptions(specs) {
  var wrap = document.querySelector('#sw-flow-toggle .sw-hf-opts');
  if (!wrap) return;
  var extras = wrap.querySelectorAll('.sw-flow-extra');
  for (var i = 0; i < extras.length; i++) extras[i].remove();
  var packages = (specs && specs.packages) || {};
  Object.keys(packages).forEach(function(name) {
    if (name === 'high') return;
    var pack = packages[name];
    if (pack.flowMin == null) return;
    var el = document.createElement('div');
    el.className = 'sw-hf-opt sw-flow-opt sw-flow-extra';
    el.setAttribute('data-flow', name);
    el.addEventListener('click', function() { selectFlowType(el); });
    el.innerHTML = '<span class="sw-hf-opt-name">' + escapeHtml(pack.label || name) + '</span>' +
      '<span class="sw-hf-opt-gpms">' + formatFlow(pack.flowMin, pack.flowMax) + ' GPM</span>';
    wrap.appendChild(el);
  });
  var allowed = { standard: 1, high: 1 };
  Object.keys(packages).forEach(function(name) { allowed[name] = 1; });
  if (!allowed[STATE.flowMode]) {
    STATE.flowMode = 'standard';
    var opts = document.querySelectorAll('.sw-flow-opt');
    for (var n = 0; n < opts.length; n++) opts[n].classList.remove('active');
    var std = document.querySelector('.sw-flow-opt[data-flow="standard"]');
    if (std) std.classList.add('active');
  }
}


/* ══════════════════════════════════════════════════════════
   RUN COMPATIBILITY CHECK
   ══════════════════════════════════════════════════════════ */
function applyMechanicalChecks(ms, as, rows, notes, fails, warns, machineType, listedFit) {
  machineType = machineType || STATE.machineType;
  listedFit = listedFit || attachmentListsSelectedMachine(as);
  var typeStatus = machineTypeCompat(as.machineTypes, machineType);
  if (typeStatus !== 'unknown') {
    var attTypes = as.machineTypes.map(function(t) { return TYPE_LABELS[t] || t; }).join(', ');
    var st = typeStatus === 'ok' ? 'ok' : typeStatus === 'warn' ? 'warn' : 'fail';
    if (st === 'fail') {
      fails++;
      notes.push('This attachment is built for ' + attTypes + ', not a ' + (TYPE_LABELS[machineType] || machineType) + '.');
    } else if (st === 'warn') {
      warns++;
      notes.push('Listed for ' + attTypes + '. Confirm size and mount before buying.');
    }
    rows.push({ name:'Machine Type', machine: TYPE_LABELS[machineType] || machineType, att: attTypes, status: st });
  }

  if (as.carrierMin || as.carrierMax) {
    var cw = machineCarrierWeight(machineType, ms);
    var range = '';
    if (as.carrierMin && as.carrierMax) range = as.carrierMin.toLocaleString() + '–' + as.carrierMax.toLocaleString() + ' lbs';
    else if (as.carrierMin) range = as.carrierMin.toLocaleString() + '+ lbs';
    else range = 'up to ' + as.carrierMax.toLocaleString() + ' lbs';
    if (cw.lbs) {
      var sc = 'ok';
      var mLabel = cw.lbs.toLocaleString() + ' lbs' + (cw.estimated ? ' (est.)' : '');
      if (as.carrierMin && cw.lbs < as.carrierMin * 0.95 && !(listedFit && cw.lbs >= as.carrierMin * 0.85)) {
        sc = 'fail'; fails++;
        notes.push('Machine is below the recommended minimum carrier weight (' + as.carrierMin.toLocaleString() + ' lbs). Attachment is too large.');
      } else if (as.carrierMax && cw.lbs > as.carrierMax * 1.08 && !listedFit) {
        sc = 'fail'; fails++;
        notes.push('Machine exceeds the recommended maximum carrier weight (' + as.carrierMax.toLocaleString() + ' lbs). Attachment is too small.');
      } else if (listedFit && ((as.carrierMin && cw.lbs < as.carrierMin) || (as.carrierMax && cw.lbs > as.carrierMax))) {
        sc = 'ok';
        notes.push('This attachment is listed for this exact model. Class weight bands are approximate.');
      }
      if (cw.estimated) notes.push('Carrier weight is estimated from rated operating capacity. Confirm operating weight in the machine manual.');
      rows.push({ name:'Carrier Weight', machine: mLabel, att: range, status: sc });
    } else {
      rows.push({ name:'Carrier Weight', machine: 'Unknown', att: range, status: 'warn' });
      warns++;
      notes.push('Could not verify carrier weight for this machine. Compare operating weight to ' + range + '.');
    }
  }

  var machCoupler = machineCoupler(machineType, ms);
  if (as.coupler && machCoupler) {
    var cc = listedFit ? 'ok' : couplerCompat(as.coupler, machCoupler, machineType);
    var sc2 = cc === 'ok' ? 'ok' : cc === 'adapter' ? 'warn' : cc === 'unknown' ? 'warn' : 'fail';
    if (sc2 === 'warn' && cc === 'adapter') { warns++; notes.push('Mount types differ (' + as.coupler + ' \u2192 ' + machCoupler + '). Adapter plate or coupler may be required.'); }
    if (sc2 === 'warn' && cc === 'unknown') { warns++; notes.push('Could not confirm mount compatibility.'); }
    if (sc2 === 'fail') { fails++; notes.push('Mount incompatible: ' + as.coupler + ' will not fit ' + machCoupler + '.'); }
    rows.push({ name:'Mount', machine: machCoupler, att: as.coupler, status: sc2 });
  }

  return { fails: fails, warns: warns };
}

function evaluateAttachmentCompat(machineType, ms, as, options) {
  options = options || {};
  var flowMode = options.flowMode || 'standard';
  var rigid = options.rigid === true;
  var rows  = [];
  var notes = [];
  var fails = 0, warns = 0;
  if (!ms || !as || !machineType) {
    return { r: 'fail', fails: 1, warns: 0, notes: ['Missing machine or attachment specs'], rows: rows };
  }

  var listedFit = attachmentListsSelectedMachine(as, options.machineName || (STATE && STATE.machineName));
  var mech = applyMechanicalChecks(ms, as, rows, notes, fails, warns, machineType, listedFit);
  fails = mech.fails; warns = mech.warns;

  /* ── TRACTOR BRANCH ──────────────────────────────────── */
  if (machineType === 'tractor') {
    if (as.hitchMin && ms.hitch) {
      var parts = String(ms.hitch).split('-').map(Number);
      var hMin = Math.min.apply(null, parts), hMax = Math.max.apply(null, parts);
      var attH = as.hitchMin === as.hitchMax || !as.hitchMax ? String(as.hitchMin) : as.hitchMin + '–' + as.hitchMax;
      var sh = 'ok';
      var attLo = as.hitchMin, attHi = as.hitchMax || as.hitchMin;
      if (attHi < hMin || attLo > hMax) {
        sh = 'fail'; fails++;
        notes.push('3-point category mismatch: attachment is Cat ' + attH + ', tractor is Cat ' + ms.hitch + '.');
      } else if (attLo !== hMin || attHi !== hMax) {
        sh = 'warn'; warns++;
        notes.push('Hitch overlap only. Confirm Cat ' + attH + ' pins/bushings on this Cat ' + ms.hitch + ' tractor.');
      }
      rows.push({ name:'3-Point Hitch', machine: 'Cat ' + ms.hitch, att: 'Cat ' + attH, status: sh });
    }

    if (rigid) {
      return summarizeCompat(fails, warns, notes, rows);
    }
    var machFlowMin = ms.auxFlowMin;
    var machFlowMax = ms.auxFlowMax;

    if (as.flowMin !== null || as.flowMax !== null) {
      var attMin = as.flowMin, attMax = as.flowMax;
      var mHave = machFlowMin + '–' + machFlowMax + ' GPM (aux)';
      var aNeed = (attMin || '?') + (attMax && attMax !== attMin ? '–' + attMax : '') + ' GPM';
      var s = 'ok';
      if (attMin && attMin > machFlowMax) {
        s = 'fail'; fails++;
        notes.push('Attachment requires at least ' + attMin + ' GPM. Tractor aux max is ' + machFlowMax + ' GPM. Insufficient flow.');
      } else if (attMax && machFlowMin > attMax) {
        s = 'warn'; warns++;
        notes.push('Tractor aux flow is above the attachment maximum (' + attMax + ' GPM). Use a flow control if required.');
      }
      rows.push({ name:'Aux Flow (GPM)', machine: mHave, att: aNeed, status: s });
    }

    if (as.psiMax !== null && ms.psiMax) {
      var mHave2 = 'Up to ' + ms.psiMax.toLocaleString() + ' PSI';
      var aNeed2 = 'Max ' + as.psiMax.toLocaleString() + ' PSI';
      var s2 = 'ok';
      if (ms.psiMax > as.psiMax * 1.05) {
        s2 = 'fail'; fails++;
        notes.push('Machine relief (' + ms.psiMax.toLocaleString() + ' PSI) exceeds the attachment maximum (' + as.psiMax.toLocaleString() + ' PSI).');
      }
      rows.push({ name:'Pressure', machine: mHave2, att: aNeed2, status: s2 });
    }

    if (as.engineMin || as.engineMax) {
      var eNeed = 'n/a';
      if (as.engineMin && as.engineMax) eNeed = as.engineMin + '–' + as.engineMax + ' hp';
      else if (as.engineMin) eNeed = as.engineMin + '+ hp';
      else eNeed = 'up to ' + as.engineMax + ' hp';
      var eHave = ms.engineHP ? ms.engineHP + ' hp' : 'Unknown';
      var se = 'ok';
      if (ms.engineHP && as.engineMin && ms.engineHP < as.engineMin) {
        se = 'fail'; fails++;
        notes.push('Tractor engine is ' + ms.engineHP + ' hp. This attachment needs at least ' + as.engineMin + ' engine hp.');
      } else if (ms.engineHP && as.engineMax && ms.engineHP > as.engineMax * 1.08) {
        se = 'fail'; fails++;
        notes.push('Tractor engine (' + ms.engineHP + ' hp) exceeds the attachment maximum (' + as.engineMax + ' hp).');
      }
      rows.push({ name:'Engine HP', machine: eHave, att: eNeed, status: se });
    } else if (ms.engineHP) {
      rows.push({ name:'Engine HP', machine: ms.engineHP + ' hp', att: '\u2014 (reference)', status: 'ok' });
    }

    if (as.ptoMin || as.ptoMax || ms.ptoHP) {
      var ptoNeed = 'n/a';
      if (as.ptoMin && as.ptoMax) ptoNeed = as.ptoMin + '–' + as.ptoMax + ' hp';
      else if (as.ptoMin) ptoNeed = as.ptoMin + '+ hp';
      else if (as.ptoMax) ptoNeed = 'up to ' + as.ptoMax + ' hp';
      var ptoHave = ms.ptoHP ? ms.ptoHP + ' hp' : 'Unknown';
      var sp = 'ok';
      if (ms.ptoHP && as.ptoMin && ms.ptoHP < as.ptoMin) {
        sp = 'fail'; fails++;
        notes.push('Tractor PTO is ' + ms.ptoHP + ' hp. This attachment needs at least ' + as.ptoMin + ' PTO hp (typical for a PTO mulcher).');
      } else if (ms.ptoHP && as.ptoMin && ms.ptoHP < as.ptoMin * 1.1) {
        sp = 'warn'; warns++;
        notes.push('PTO hp is close to the minimum. Expect reduced cutting speed under load.');
      }
      if (ms.ptoHP && as.ptoMax && ms.ptoHP > as.ptoMax) {
        sp = 'fail'; fails++;
        notes.push('Tractor PTO (' + ms.ptoHP + ' hp) exceeds the attachment maximum (' + as.ptoMax + ' hp). Overpowering a PTO mulcher can damage the gearbox.');
      }
      if (!ms.ptoHP && as.ptoMin) {
        sp = 'warn'; warns++;
        notes.push('Could not confirm tractor PTO hp. Attachment wants ' + ptoNeed + '.');
      }
      rows.push({ name:'PTO HP', machine: ptoHave, att: ptoNeed, status: sp });
    }

    if (as.flowMin || as.psiMax) notes.push('\u2139\uFE0F Tractor hydraulic check uses aux flow and pressure.');
    notes.push('\u2139\uFE0F PTO mulcher match uses published PTO hp and hitch category. Confirm 540 vs 1000 rpm.');

    return summarizeCompat(fails, warns, notes, rows);
  }

  /* ── NON-TRACTOR BRANCH ──────────────────────────────── */
  if (rigid) {
    return summarizeCompat(fails, warns, notes, rows);
  }

  var active = activeHydraulics(ms, flowMode);
  var isHF = active.optional;
  var machineFlowMin = active.flowMin;
  var machineFlowMax = active.flowMax;
  var machinePsi = active.psi;

  // Flow Rate
  if (as.flowMin !== null || as.flowMax !== null) {
    var aMin = as.flowMin, aMax = as.flowMax;
    var aN = (aMin || '?') + (aMax && aMax !== aMin ? '–' + aMax : '') + ' GPM';
    var st = 'ok';
    var mH = 'Not published';
    if (machineFlowMax == null) {
      st = 'warn'; warns++;
      notes.push('Auxiliary flow is not published for this configuration.');
    } else {
      mH = formatFlow(machineFlowMin, machineFlowMax) + ' GPM' + (isHF ? ' \u26A1' : '');
      if (aMin && aMin > machineFlowMax) {
        st = 'fail'; fails++;
        notes.push('Attachment needs at least ' + aMin + ' GPM. Machine delivers max ' + machineFlowMax + ' GPM. Insufficient power.');
        if (!isHF && ms.hfFlowMin && aMin <= ms.hfFlowMax) {
          notes.push('\u26A1 High-flow upgrade may resolve this \u2014 ' + ms.hfFlowMin + '–' + ms.hfFlowMax + ' GPM.');
        }
      } else if (aMax && machineFlowMin > aMax) {
        st = 'warn'; warns++;
        notes.push('Machine flow is above the attachment maximum (' + aMax + ' GPM). Use a flow control if the motor is not rated for this flow.');
      }
    }
    rows.push({ name:'Flow (GPM)', machine: mH, att: aN, status: st });
  }

  // Pressure — attachment PSI is a ceiling. Machine must not exceed it.
  // Optional packages use their own published auxiliary pressure. A blank
  // import keeps the existing catalog pressure and does not borrow the
  // standard-circuit pressure.
  if (as.psiMax !== null) {
    var mP = machinePsi ? 'Up to ' + Number(machinePsi).toLocaleString() + ' PSI' : 'N/A';
    var aP = 'Max ' + as.psiMax.toLocaleString() + ' PSI';
    var sp = 'ok';
    if (machinePsi && machinePsi > as.psiMax * 1.05) {
      sp = 'fail'; fails++;
      notes.push('Machine relief (' + Number(machinePsi).toLocaleString() + ' PSI) exceeds the attachment maximum (' + as.psiMax.toLocaleString() + ' PSI).');
    }
    rows.push({ name:'Pressure', machine: mP, att: aP, status: sp });
  }

  // Weight / ROC — SSL/CTL only. Never treat carrier-class max as attachment mass.
  var isEx = machineType === 'excavator' || machineType === 'mini-excavator' || machineType === 'material-handler';
  if (!isEx && as.weight && ms.capacity && as.weight < 8000) {
    var pct = as.weight / ms.capacity;
    var mW = ms.capacity.toLocaleString() + ' lbs';
    var aW = as.weight.toLocaleString() + ' lbs';
    var sw = 'ok';
    if (pct > 1.0) { sw = 'fail'; fails++; notes.push('Attachment exceeds rated operating capacity. Tip-over risk.'); }
    rows.push({ name:'Weight / Cap.', machine: mW, att: aW, status: sw });
  }

  return summarizeCompat(fails, warns, notes, rows);
}

function summarizeCompat(fails, warns, notes, rows) {
  var r = 'pass';
  if (fails > 0) r = 'fail';
  else if (warns > 0 || !rows.length) r = 'warn';
  return { r: r, fails: fails, warns: warns, notes: notes, rows: rows };
}

function runCheck() {
  fitTrack('fit_check');
  var result = evaluateAttachmentCompat(STATE.machineType, STATE.machineSpecs, STATE.attSpecs, {
    flowMode: STATE.flowMode,
    rigid: false
  });
  renderVerdict(result.rows, result.notes, result.fails, result.warns);
}


/* ══════════════════════════════════════════════════════════
   RENDER VERDICT & RESULTS
   ══════════════════════════════════════════════════════════ */
function renderVerdict(rows, notes, fails, warns) {
  var ms = STATE.machineSpecs;
  var as = STATE.attSpecs;
  var suggested = renderFitLead(fails);

  // Verdict banner
  var verdict = document.getElementById('sw-verdict');
  verdict.className = 'sw-verdict';
  if (fails > 0 && suggested && (suggested.type === 'variant' || suggested.type === 'related')) {
    verdict.classList.add('suggest');
    document.getElementById('sw-verdict-title').textContent = suggested.type === 'related'
      ? 'Different Product Fits'
      : 'Switch Options To Fit';
    document.getElementById('sw-verdict-sub').textContent = suggested.type === 'related'
      ? 'This listing is the wrong size for your ' + STATE.machineName + '. We found models that match.'
      : 'This option does not fit your ' + STATE.machineName + '. Use the recommended option below.';
  } else if (fails > 0) {
    verdict.classList.add('fail');
    document.getElementById('sw-verdict-title').textContent = 'Not Compatible';
    document.getElementById('sw-verdict-sub').textContent = fails + ' critical issue' + (fails>1?'s':'') + ' with your ' + STATE.machineName + '. Not recommended.';
  } else if (warns > 0) {
    verdict.classList.add('warn');
    document.getElementById('sw-verdict-title').textContent = 'Conditionally Compatible';
    document.getElementById('sw-verdict-sub').textContent = 'Some specs are at the edge of your machine\u2019s capability. Request a quote if you want us to confirm fitment.';
  } else if (!rows.length) {
    verdict.classList.add('warn');
    document.getElementById('sw-verdict-title').textContent = 'Not Enough Specs';
    document.getElementById('sw-verdict-sub').textContent = 'We could not confirm machine type, mount, or hydraulics for this attachment. Check the listing or contact us.';
  } else {
    verdict.classList.add('pass');
    document.getElementById('sw-verdict-title').textContent = 'Compatible';
    document.getElementById('sw-verdict-sub').textContent = 'Published specs are inside this attachment\u2019s range. Installed coupler, serial, and configuration are not verified.';
  }

  var outcome = 'fail';
  if (verdict.classList.contains('pass')) outcome = 'pass';
  else if (verdict.classList.contains('suggest')) outcome = (suggested && suggested.type === 'related') ? 'suggest_product' : 'suggest_variant';
  else if (verdict.classList.contains('warn')) outcome = 'warn';
  fitTrack('fit_result', { fit_outcome: outcome });
  ingestFitCheck(outcome, suggested);

  // Spec table
  document.getElementById('sw-spec-tbody').innerHTML = rows.map(function(r) {
    var hint = '';
    if (suggested && suggested.variant && r.status === 'fail') {
      hint = '<div class="sw-row-hint">Fits ' + escapeHtml(variantLabel(suggested.variant)) + '</div>';
    }
    return '<tr>' +
      '<td data-label="Spec">' + r.name + '</td>' +
      '<td data-label="Machine">' + r.machine + '</td>' +
      '<td data-label="Required">' + r.att + hint + '</td>' +
      '<td data-label="Result"><span class="status-pill ' + r.status + '"><span class="status-dot"></span>' +
        (r.status === 'ok' ? 'Pass' : r.status === 'warn' ? 'Caution' : 'Fail') +
      '</span></td></tr>';
  }).join('');

  // Notes panel removed from the product widget.

  // Flow comparison (non-tractors with high-flow support)
  var flowCompare = document.getElementById('sw-flow-compare');
  var optionalPack = ms.packages && STATE.flowMode !== 'standard' && ms.packages[STATE.flowMode] && ms.packages[STATE.flowMode].flowMin != null
    ? ms.packages[STATE.flowMode]
    : (ms.hfFlowMin ? { label: 'High Flow', flowMin: ms.hfFlowMin, flowMax: ms.hfFlowMax } : null);
  if (STATE.machineType !== 'tractor' && MACHINES[STATE.machineType] && MACHINES[STATE.machineType].supportsHighFlow && ms.flowMin != null && optionalPack && optionalPack.flowMin && as.flowMin) {
    flowCompare.classList.add('visible');
    var stdOk = checkFlowResult(as.flowMin, as.flowMax, ms.flowMin, ms.flowMax);
    var hfOk  = checkFlowResult(as.flowMin, as.flowMax, optionalPack.flowMin, optionalPack.flowMax);
    var optionalSelected = STATE.flowMode !== 'standard';
    document.getElementById('sw-flow-compare-grid').innerHTML =
      '<div class="flow-col ' + (!optionalSelected ? 'active' : '') + '">' +
        '<div class="flow-col-head">Standard Flow ' + (!optionalSelected ? '<span class="current-badge">Selected</span>' : '') + '</div>' +
        '<div class="flow-col-gpms">' + formatFlow(ms.flowMin, ms.flowMax) + ' GPM</div>' +
        '<div class="flow-col-status-wrap"><span class="status-pill ' + stdOk + '"><span class="status-dot"></span>' + (stdOk === 'ok' ? 'Pass' : stdOk === 'warn' ? 'Caution' : 'Fail') + '</span></div>' +
        '<div class="flow-col-machines">Standard configuration</div>' +
      '</div>' +
      '<div class="flow-col ' + (optionalSelected ? 'active' : '') + '">' +
        '<div class="flow-col-head">\u26A1 ' + escapeHtml(optionalPack.label || 'High Flow') + (optionalSelected ? ' <span class="current-badge">Selected</span>' : '') + '</div>' +
        '<div class="flow-col-gpms">' + formatFlow(optionalPack.flowMin, optionalPack.flowMax) + ' GPM</div>' +
        '<div class="flow-col-status-wrap"><span class="status-pill ' + hfOk + '"><span class="status-dot"></span>' + (hfOk === 'ok' ? 'Pass' : hfOk === 'warn' ? 'Caution' : 'Fail') + '</span></div>' +
        '<div class="flow-col-machines">Optional package. Confirm it is installed.</div>' +
      '</div>';
  } else {
    flowCompare.classList.remove('visible');
  }


  document.getElementById('sw-results').classList.add('visible');
  document.getElementById('sw-results').scrollIntoView({ behavior:'smooth', block:'nearest' });
  resetAtcUi();
}

function checkFlowResult(attMin, attMax, machMin, machMax) {
  if (!attMin && !attMax) return 'ok';
  if (attMin && attMin > machMax) return 'fail';
  if (attMax && attMax > machMax) return 'warn';
  return 'ok';
}


/* ══════════════════════════════════════════════════════════
   RESET
   ══════════════════════════════════════════════════════════ */
function resetAtcUi() {
  var atcBtn = document.getElementById('sw-atc-btn');
  var success = document.getElementById('sw-atc-success');
  var err = document.getElementById('sw-atc-error');
  if (atcBtn) {
    atcBtn.hidden = false;
    atcBtn.disabled = atcBtn.getAttribute('data-sold-out') === '1';
  }
  if (success) {
    success.classList.remove('is-visible');
    var check = success.querySelector('.sw-check');
    if (check) check.innerHTML = check.innerHTML;
  }
  if (err) {
    err.textContent = '';
    err.classList.remove('is-visible');
  }
}

function resetWidget() {
  var btns = document.querySelectorAll('.sw-type');
  for (var i = 0; i < btns.length; i++) btns[i].classList.remove('active');
  STATE.machineType = null;
  STATE.machineSpecs = null;
  STATE.flowMode = 'standard';
  document.getElementById('sw-selects').classList.add('locked');
  document.getElementById('sw-make').innerHTML  = '<option value="">— Make —</option>';
  document.getElementById('sw-model').innerHTML = '<option value="">— Model —</option>';
  document.getElementById('sw-machine-preview').classList.remove('visible');
  document.getElementById('sw-flow-toggle').classList.remove('visible');
  document.getElementById('sw-flow-badge').classList.remove('visible');
  document.getElementById('sw-check-btn').disabled = true;
  document.getElementById('sw-results').classList.remove('visible');
  var flowOpts = document.querySelectorAll('.sw-flow-opt');
  for (var j = 0; j < flowOpts.length; j++) flowOpts[j].classList.remove('active');
  document.querySelector('.sw-flow-opt[data-flow="standard"]').classList.add('active');
  resetAtcUi();
}

function currentVariantId() {
  var live = document.querySelector('.js-product-form-main [name="id"]');
  if (live && live.value) return live.value;
  var widget = document.getElementById('sss-widget');
  return widget ? widget.getAttribute('data-variant-id') : '';
}

function currentQuantity() {
  var qty = document.querySelector('.js-product-form-main [name="quantity"]');
  var n = qty ? parseInt(qty.value, 10) : 1;
  return n > 0 ? n : 1;
}

function showAtcSuccess() {
  var atcBtn = document.getElementById('sw-atc-btn');
  var success = document.getElementById('sw-atc-success');
  if (atcBtn) atcBtn.hidden = true;
  if (!success) return;
  var check = success.querySelector('.sw-check');
  if (check) check.innerHTML = check.innerHTML;
  success.classList.add('is-visible');
  success.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  fitTrack('fit_atc');
  ingestLead('fit_atc');
}

function bindCompatAtc() {
  var atcBtn = document.getElementById('sw-atc-btn');
  var success = document.getElementById('sw-atc-success');
  var err = document.getElementById('sw-atc-error');
  var continueBtn = document.getElementById('sw-continue-shop');
  var checkoutBtn = document.getElementById('sw-checkout-btn');
  var widget = document.getElementById('sss-widget');
  if (!atcBtn || atcBtn.getAttribute('data-sss-atc-bound')) return;
  atcBtn.setAttribute('data-sss-atc-bound', '1');
  if (widget && widget.getAttribute('data-available') === 'false') {
    atcBtn.setAttribute('data-sold-out', '1');
    atcBtn.disabled = true;
  }
  if (checkoutBtn && widget && widget.getAttribute('data-checkout')) {
    checkoutBtn.setAttribute('href', widget.getAttribute('data-checkout'));
  }

  atcBtn.addEventListener('click', function() {
    if (atcBtn.disabled) return;
    if (err) {
      err.textContent = '';
      err.classList.remove('is-visible');
    }
    var variantId = currentVariantId();
    if (!variantId) {
      if (err) {
        err.textContent = 'Select a product option first.';
        err.classList.add('is-visible');
      }
      return;
    }
    atcBtn.disabled = true;
    var cartAdd = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = 'cart-icon-bubble';
    if (cartDrawer) {
      var sectionEl = cartDrawer.closest('.shopify-section');
      if (sectionEl && sectionEl.id) sections += ',' + sectionEl.id.replace('shopify-section-', '');
    }
    fetch(cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: currentQuantity(),
        sections: sections,
        sections_url: window.location.pathname
      })
    }).then(function(res) {
      return res.json().then(function(data) {
        if (!res.ok || data.status) {
          var msg = data.description || data.message || 'Could not add to cart.';
          throw new Error(typeof msg === 'string' ? msg : 'Could not add to cart.');
        }
        return data;
      });
    }).then(function(data) {
      var icon = document.getElementById('cart-icon-bubble');
      if (icon && data.sections && data.sections['cart-icon-bubble']) {
        icon.innerHTML = data.sections['cart-icon-bubble'];
      }
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data, false);
      }
      showAtcSuccess();
    }).catch(function(e) {
      atcBtn.disabled = false;
      if (err) {
        err.textContent = (e && e.message) ? e.message : 'Could not add to cart.';
        err.classList.add('is-visible');
      }
    });
  });

  if (continueBtn) {
    continueBtn.addEventListener('click', function() {
      var closeBtn = document.getElementById('sw-popup-close');
      if (closeBtn) closeBtn.click();
    });
  }
}


/* ══════════════════════════════════════════════════════════
   ENTRY POINT — Called by the Liquid snippet
   initCompatWidget( product.description )
   ══════════════════════════════════════════════════════════ */
var STORAGE_KEY = 'sss_machine';

function persistMachine() {
  var machine = {
    type: STATE.machineType,
    make: document.getElementById('sw-make').value,
    model: document.getElementById('sw-model').value,
    flow: STATE.flowMode
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(machine));
  } catch (e) {}
  // Restores replay the saved machine on every page load; syncing then would
  // overwrite corrections the customer typed into the cart fields.
  if (!STATE._restore) syncMachineToCart(machine);
}

/* Cart attribute names are shared with snippets/cart-machine.liquid,
   assets/cart-machine.js and the CRM order webhook. */
function syncMachineToCart(machine) {
  if (!machine.make || !machine.model) return;
  var attributes = {
    'Machine Make': machine.make,
    'Machine Model': machine.model,
    'High Flow': machine.flow && machine.flow !== 'standard' ? 'Yes' : 'No'
  };

  var fields = document.querySelectorAll('cart-machine');
  for (var i = 0; i < fields.length; i++) {
    var make = fields[i].querySelector('[data-machine-field="make"]');
    var model = fields[i].querySelector('[data-machine-field="model"]');
    var highFlow = fields[i].querySelector('[data-machine-field="high_flow"]');
    var highFlowValue = fields[i].querySelector('[data-machine-high-flow-value]');
    if (make) make.value = attributes['Machine Make'];
    if (model) model.value = attributes['Machine Model'];
    if (highFlow) highFlow.checked = attributes['High Flow'] === 'Yes';
    if (highFlowValue) highFlowValue.value = attributes['High Flow'];
    fields[i].setAttribute('data-saved-high-flow', attributes['High Flow']);
  }

  if (window.CartMachineNote) {
    window.CartMachineNote.preview({ attributes: attributes });
    window.CartMachineNote.save({ attributes: attributes });
    return;
  }

  var url = (window.theme && theme.routes && theme.routes.cartUpdate) || '/cart/update';
  try {
    fetch(url, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  } catch (e) {}
}

function restoreMachine() {
  try {
    var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (!saved || !saved.type) return;
    STATE._restore = true;
    var btn = document.querySelector('.sw-type[data-type="' + saved.type + '"]');
    if (!btn) { STATE._restore = false; return; }
    selectType(btn);
    if (saved.make) {
      document.getElementById('sw-make').value = saved.make;
      updateModels();
    }
    if (saved.flow) STATE.flowMode = saved.flow;
    if (saved.model) {
      document.getElementById('sw-model').value = saved.model;
      updateMachinePreview();
    }
    if (saved.flow) {
      var opt = document.querySelector('.sw-flow-opt[data-flow="' + saved.flow + '"]');
      if (opt) selectFlowType(opt);
    }
  } catch (e) {}
  STATE._restore = false;
}

function parseCarrierRangeFromText(text) {
  var t = String(text || '').replace(/,/g, '');
  var m = t.match(/(\d{3,6})\s*[-–to]+\s*(\d{3,6})(?:\s*(?:lbs?|pounds?))?(?:\s*carrier)?/i);
  if (!m) return null;
  var a = parseFloat(m[1]);
  var b = parseFloat(m[2]);
  if (a >= 800 && b > a && b <= 200000) return { min: a, max: b };
  return null;
}

function sanitizeAttWeight(parsed) {
  if (!parsed || parsed.weight == null) return parsed;
  if (parsed.carrierMax && parsed.weight >= parsed.carrierMax * 0.8) parsed.weight = null;
  else if (parsed.weight >= 10000) parsed.weight = null;
  return parsed;
}

function variantBlob(v) {
  return v ? ((v.title || '') + ' ' + ((v.options || []).join(' '))) : '';
}

function findVariantById(id) {
  var n = parseInt(id, 10);
  var list = window.SSS_VARIANTS || [];
  for (var i = 0; i < list.length; i++) {
    if (parseInt(list[i].id, 10) === n) return list[i];
  }
  return null;
}

function cloneAttSpecs(src) {
  src = src || STATE.attSpecs || {};
  var o = {};
  for (var k in src) {
    if (!Object.prototype.hasOwnProperty.call(src, k)) continue;
    o[k] = Array.isArray(src[k]) ? src[k].slice() : src[k];
  }
  return o;
}

function snapshotSpecs(s) {
  s = s || {};
  return {
    carrierMin: s.carrierMin, carrierMax: s.carrierMax, weight: s.weight,
    machineTypes: (s.machineTypes || []).slice(),
    ptoMin: s.ptoMin, ptoMax: s.ptoMax,
    engineMin: s.engineMin, engineMax: s.engineMax,
    hitchMin: s.hitchMin, hitchMax: s.hitchMax,
    flowMin: s.flowMin, flowMax: s.flowMax, psiMax: s.psiMax,
    coupler: s.coupler
  };
}

function applySnapshot(specs, snap) {
  if (!specs || !snap) return specs;
  specs.carrierMin = snap.carrierMin;
  specs.carrierMax = snap.carrierMax;
  specs.weight = snap.weight;
  specs.machineTypes = (snap.machineTypes || []).slice();
  specs.ptoMin = snap.ptoMin;
  specs.ptoMax = snap.ptoMax;
  specs.engineMin = snap.engineMin;
  specs.engineMax = snap.engineMax;
  specs.hitchMin = snap.hitchMin;
  specs.hitchMax = snap.hitchMax;
  specs.flowMin = snap.flowMin;
  specs.flowMax = snap.flowMax;
  specs.psiMax = snap.psiMax;
  specs.coupler = snap.coupler;
  return specs;
}

function overlayVariantOnSpecs(specs, v, base) {
  if (!specs) return specs;
  applySnapshot(specs, base || STATE.baseAttSpecs);
  if (!v) {
    sanitizeAttWeight(specs);
    return specs;
  }
  var blob = variantBlob(v);
  var parsed = parseSpecs(blob, blob);
  var range = parseCarrierRangeFromText(blob);
  if (range) {
    specs.carrierMin = range.min;
    specs.carrierMax = range.max;
  } else {
    if (parsed.carrierMin != null) specs.carrierMin = parsed.carrierMin;
    if (parsed.carrierMax != null) specs.carrierMax = parsed.carrierMax;
  }
  if (parsed.ptoMin != null) specs.ptoMin = parsed.ptoMin;
  if (parsed.ptoMax != null) specs.ptoMax = parsed.ptoMax;
  if (parsed.hitchMin != null) specs.hitchMin = parsed.hitchMin;
  if (parsed.hitchMax != null) specs.hitchMax = parsed.hitchMax;
  if (parsed.flowMin != null) specs.flowMin = parsed.flowMin;
  if (parsed.flowMax != null) specs.flowMax = parsed.flowMax;
  if (parsed.psiMax != null) specs.psiMax = parsed.psiMax;
  if (parsed.coupler) specs.coupler = parsed.coupler;
  if (parsed.machineTypes && parsed.machineTypes.length) {
    for (var i = 0; i < parsed.machineTypes.length; i++) {
      if (specs.machineTypes.indexOf(parsed.machineTypes[i]) === -1) {
        specs.machineTypes.push(parsed.machineTypes[i]);
      }
    }
  }
  if (range && (/mini/.test(blob.toLowerCase()) || range.max <= 14000)) {
    if (specs.machineTypes.indexOf('mini-excavator') === -1) {
      specs.machineTypes.push('mini-excavator');
    }
  }
  sanitizeAttWeight(specs);
  return specs;
}

function applySelectedVariantToSpecs() {
  if (!STATE.attSpecs) return;
  if (!STATE.baseAttSpecs) STATE.baseAttSpecs = snapshotSpecs(STATE.attSpecs);
  overlayVariantOnSpecs(STATE.attSpecs, findVariantById(currentVariantId()), STATE.baseAttSpecs);
  updateParsedStrip();
}

function evalOptions() {
  return { flowMode: STATE.flowMode, rigid: false, machineName: STATE.machineName };
}

function tightnessScore(specs) {
  if (!specs || !STATE.machineSpecs) return 1e9;
  var ms = STATE.machineSpecs;
  var score = 0;
  var cw = machineCarrierWeight(STATE.machineType, ms);
  if (specs.carrierMin != null && specs.carrierMax != null && cw.lbs) {
    score += (specs.carrierMax - specs.carrierMin);
    score += Math.abs((specs.carrierMin + specs.carrierMax) / 2 - cw.lbs) * 0.2;
  }
  if (specs.ptoMin != null && specs.ptoMax != null && ms.ptoHP) {
    score += (specs.ptoMax - specs.ptoMin) * 40;
    score += Math.abs((specs.ptoMin + specs.ptoMax) / 2 - ms.ptoHP) * 8;
  }
  if (specs.flowMin != null && specs.flowMax != null) {
    score += (specs.flowMax - specs.flowMin) * 12;
  }
  return score;
}

function sortFits(a, b) {
  return tightnessScore(a.specs) - tightnessScore(b.specs);
}

function findFittingVariants() {
  var list = window.SSS_VARIANTS || [];
  var currentId = parseInt(currentVariantId(), 10);
  var fits = [];
  for (var i = 0; i < list.length; i++) {
    var v = list[i];
    if (parseInt(v.id, 10) === currentId) continue;
    if (v.available === false) continue;
    var specs = overlayVariantOnSpecs(cloneAttSpecs(), v, STATE.baseAttSpecs);
    var result = evaluateAttachmentCompat(STATE.machineType, STATE.machineSpecs, specs, evalOptions());
    if (result.fails === 0) {
      fits.push({ variant: v, specs: specs, result: result });
    }
  }
  fits.sort(sortFits);
  return fits;
}

function specsForRelatedProduct(p, v) {
  var extra = ((p.title || '') + ' ' + (p.type || '')).trim();
  var html = p.html || '';
  var specs = mergeMetafields(parseSpecs(html, extra), p.mf || {});
  applyTableHpOverlay(specs, html, extra);
  specs.extraText = extra;
  sanitizeAttWeight(specs);
  var base = snapshotSpecs(specs);
  return overlayVariantOnSpecs(specs, v, base);
}

function findFittingRelated() {
  var list = window.SSS_RELATED || [];
  var currentId = parseInt(currentVariantId(), 10);
  var byProduct = {};
  for (var i = 0; i < list.length; i++) {
    var p = list[i];
    var variants = (p.variants && p.variants.length) ? p.variants : [{ id: p.id, title: p.title, options: [], available: p.available !== false }];
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];
      if (v.available === false) continue;
      if (parseInt(v.id, 10) === currentId) continue;
      var specs = specsForRelatedProduct(p, v);
      var result = evaluateAttachmentCompat(STATE.machineType, STATE.machineSpecs, specs, evalOptions());
      if (result.fails !== 0) continue;
      var item = { product: p, variant: v, specs: specs, result: result };
      var key = String(p.id);
      if (!byProduct[key] || tightnessScore(specs) < tightnessScore(byProduct[key].specs)) {
        byProduct[key] = item;
      }
    }
  }
  var fits = [];
  for (var k in byProduct) {
    if (Object.prototype.hasOwnProperty.call(byProduct, k)) fits.push(byProduct[k]);
  }
  fits.sort(sortFits);
  return fits;
}

function renderAltButtons(el, fits) {
  if (!el) return;
  el.innerHTML = fits.map(function(item) {
    return '<button type="button" class="sw-alt-btn" data-variant-id="' + item.variant.id + '">' +
      escapeHtml(variantLabel(item.variant)) + '</button>';
  }).join('');
}

function relatedCard(item) {
  var url = item.product.url || ('/products/' + (item.product.handle || ''));
  if (item.variant && item.variant.id) {
    url += (url.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + item.variant.id;
  }
  var vlab = variantLabel(item.variant);
  var img = item.product.image
    ? '<img class="sw-related-img" src="' + escapeHtml(item.product.image) + '" alt="">'
    : '';
  return '<a class="sw-related-card" href="' + escapeHtml(url) + '">' + img +
    '<span class="sw-related-card-body"><b>' + escapeHtml(item.product.title || '') + '</b>' +
    (vlab && vlab !== item.product.title ? '<span class="sw-related-opt">' + escapeHtml(vlab) + '</span>' : '') +
    (item.product.price ? '<span class="sw-related-price">' + escapeHtml(item.product.price) + '</span>' : '') +
    '<span class="sw-related-cta">View this model \u2192</span></span></a>';
}

function bindVariantSuggest() {
  var wrap = document.getElementById('sw-variant-suggest');
  if (!wrap || wrap.getAttribute('data-sss-bound')) return;
  wrap.setAttribute('data-sss-bound', '1');
  wrap.addEventListener('click', function(e) {
    var card = e.target.closest && e.target.closest('a.sw-related-card');
    if (card) {
      fitTrack('fit_related_click', { fit_related: card.getAttribute('href') || '' });
      return;
    }
    var btn = e.target.closest('[data-variant-id]');
    if (!btn || btn.tagName === 'A') return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (id) selectProductVariant(id);
  });
}

function renderFitLead(fails) {
  var wrap = document.getElementById('sw-variant-suggest');
  var btn = document.getElementById('sw-variant-suggest-btn');
  var copy = document.getElementById('sw-variant-suggest-copy');
  var alts = document.getElementById('sw-variant-suggest-alts');
  var relatedEl = document.getElementById('sw-related-fits');
  if (!wrap || !btn || !copy) return null;
  wrap.hidden = true;
  btn.hidden = false;
  btn.removeAttribute('data-url');
  copy.textContent = '';
  if (alts) alts.innerHTML = '';
  if (relatedEl) relatedEl.innerHTML = '';
  if (!STATE.machineSpecs) return null;

  var variants = findFittingVariants();
  var related = (fails && !variants.length) ? findFittingRelated() : [];

  if (!fails && variants.length) {
    copy.textContent = 'Your ' + STATE.machineName + ' also fits other options on this product.';
    btn.hidden = true;
    renderAltButtons(alts, variants.slice(0, 3));
    wrap.hidden = false;
    return { type: 'alts', variant: variants[0] };
  }

  if (fails && variants.length) {
    var best = variants[0];
    var label = variantLabel(best.variant);
    copy.textContent = 'This option does not fit your ' + STATE.machineName + '. Switch to the option that does.';
    btn.hidden = false;
    btn.setAttribute('data-variant-id', String(best.variant.id));
    btn.textContent = 'Use ' + label;
    btn.setAttribute('aria-label', 'Switch to ' + label);
    if (variants.length > 1) renderAltButtons(alts, variants.slice(1, 4));
    wrap.hidden = false;
    return { type: 'variant', variant: best.variant };
  }

  if (fails && related.length) {
    copy.textContent = 'This product is not the right size for your ' + STATE.machineName + '. These models are.';
    btn.hidden = true;
    if (relatedEl) relatedEl.innerHTML = related.slice(0, 3).map(relatedCard).join('');
    wrap.hidden = false;
    return { type: 'related', related: related[0] };
  }

  return null;
}

function escapeHtml(str) {
  return String(str || '').replace(/[&<>"']/g, function(ch) {
    return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
  });
}

function variantLabel(v) {
  if (!v) return '';
  if (v.title && v.title !== 'Default Title') return v.title;
  return (v.options || []).filter(Boolean).join(' / ');
}

function selectProductVariant(variantId) {
  var v = findVariantById(variantId);
  if (!v) return;
  var opts = v.options || [];
  var picker = document.querySelector('variant-picker');
  if (picker && opts.length) {
    for (var o = 0; o < opts.length; o++) {
      var wanted = String(opts[o]);
      var inputs = picker.querySelectorAll('.option-selector .js-option');
      for (var j = 0; j < inputs.length; j++) {
        if (String(inputs[j].value) !== wanted) continue;
        if (inputs[j].closest('custom-select') && typeof inputs[j].closest('custom-select').selectOption === 'function') {
          inputs[j].closest('custom-select').selectOption(inputs[j]);
        } else if (!inputs[j].checked) {
          inputs[j].click();
        }
        break;
      }
    }
  }
  var idInputs = document.querySelectorAll('.js-product-form [name="id"], [name="id"]');
  for (var k = 0; k < idInputs.length; k++) {
    idInputs[k].value = String(v.id);
    idInputs[k].dispatchEvent(new Event('change', { bubbles: true }));
  }
  var widget = document.getElementById('sss-widget');
  if (widget) widget.setAttribute('data-variant-id', String(v.id));
  applySelectedVariantToSpecs();
  fitTrack('fit_switch_variant');
  if (STATE.machineSpecs) runCheck();
}

function mergeMetafields(parsed, mf) {
  if (!mf) return parsed;
  var num = function(v) { var n = parseFloat(v); return isNaN(n) ? null : n; };
  if (mf.attachment_class === 'rigid') {
    parsed.flowMin = null;
    parsed.flowMax = null;
    parsed.psiMax = null;
  }
  if (mf.flow_min != null && mf.flow_min !== '') parsed.flowMin = num(mf.flow_min);
  if (mf.flow_max != null && mf.flow_max !== '') parsed.flowMax = num(mf.flow_max);
  if (mf.psi_max != null && mf.psi_max !== '') parsed.psiMax = num(mf.psi_max);
  if (mf.weight_lbs != null && mf.weight_lbs !== '') parsed.weight = num(mf.weight_lbs);
  else if (mf.weight_lbs_max != null && mf.weight_lbs_max !== '') parsed.weight = num(mf.weight_lbs_max);
  if (mf.coupler_type) parsed.coupler = mf.coupler_type;
  if (mf.extra_text) parsed.extraText = mf.extra_text;
  if (mf.carrier_weight_min != null && mf.carrier_weight_min !== '') parsed.carrierMin = num(mf.carrier_weight_min);
  if (mf.carrier_weight_max != null && mf.carrier_weight_max !== '') parsed.carrierMax = num(mf.carrier_weight_max);
  if (mf.machine_types) {
    parsed.machineTypes = String(mf.machine_types).split(',').map(function(x) { return x.trim(); }).filter(Boolean);
  }
  if (mf.pto_min != null && mf.pto_min !== '') parsed.ptoMin = num(mf.pto_min);
  if (mf.pto_max != null && mf.pto_max !== '') parsed.ptoMax = num(mf.pto_max);
  if (mf.hitch_min != null && mf.hitch_min !== '') parsed.hitchMin = num(mf.hitch_min);
  if (mf.hitch_max != null && mf.hitch_max !== '') parsed.hitchMax = num(mf.hitch_max);
  return parsed;
}

window.resolveFitSpecs = resolveFitSpecs;
window.catalogMakes = catalogMakes;
window.catalogModels = catalogModels;

function initCompatWidget(descriptionHTML, metafields) {
  var extra = '';
  if (metafields && metafields.extra_text) extra = metafields.extra_text;
  STATE.baseAttSpecs = null;
  STATE.attSpecs = mergeMetafields(parseSpecs(descriptionHTML || '', extra), metafields);
  applyTableHpOverlay(STATE.attSpecs, descriptionHTML || '', extra);
  sanitizeAttWeight(STATE.attSpecs);
  applySelectedVariantToSpecs();
  restoreMachine();
  bindCompatAtc();
  bindVariantSuggest();
  var quoteBtn = document.getElementById('sw-quote-open');
  if (quoteBtn && !quoteBtn.getAttribute('data-sss-track')) {
    quoteBtn.setAttribute('data-sss-track', '1');
    quoteBtn.addEventListener('click', function() {
      fitTrack('fit_quote_open');
    });
  }
  if (!window._sssVariantBound) {
    window._sssVariantBound = true;
    document.addEventListener('on:variant:change', function() {
      applySelectedVariantToSpecs();
      var results = document.getElementById('sw-results');
      if (results && results.classList.contains('visible') && STATE.machineSpecs) runCheck();
    });
    document.addEventListener('change', function(e) {
      if (e.target && e.target.getAttribute('name') === 'id') {
        applySelectedVariantToSpecs();
        var results = document.getElementById('sw-results');
        if (results && results.classList.contains('visible') && STATE.machineSpecs) runCheck();
      }
    });
  }
}